var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSupplementSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9997 12.6875C18.3929 12.6875 20.333 10.9293 20.333 8.76042C20.333 6.59152 18.3929 4.83333 15.9997 4.83333C13.6064 4.83333 11.6663 6.59152 11.6663 8.76042C11.6663 10.9293 13.6064 12.6875 15.9997 12.6875ZM15.9997 13.8958C19.1293 13.8958 21.6663 11.5966 21.6663 8.76042C21.6663 5.9242 19.1293 3.625 15.9997 3.625C12.8701 3.625 10.333 5.9242 10.333 8.76042C10.333 11.5966 12.8701 13.8958 15.9997 13.8958Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2565 5.98725C16.6234 6.0151 16.896 6.30724 16.8652 6.63971L16.4638 10.9821C16.4331 11.3146 16.1108 11.5616 15.7438 11.5337C15.377 11.5059 15.1044 11.2137 15.1352 10.8812L15.5366 6.53888C15.5673 6.20635 15.8896 5.95939 16.2565 5.98725Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.66667 24.1667C12.0599 24.1667 14 22.4086 14 20.2397C14 18.0708 12.0599 16.3126 9.66667 16.3126C7.2734 16.3126 5.33333 18.0708 5.33333 20.2397C5.33333 22.4086 7.2734 24.1667 9.66667 24.1667ZM9.66667 25.3751C12.7963 25.3751 15.3333 23.0759 15.3333 20.2397C15.3333 17.4035 12.7963 15.1042 9.66667 15.1042C6.53705 15.1042 4 17.4035 4 20.2397C4 23.0759 6.53705 25.3751 9.66667 25.3751Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8379 22.2076C11.5775 22.4436 11.1555 22.4436 10.8951 22.2076L7.49505 19.1263C7.23472 18.8904 7.23472 18.5078 7.49505 18.2719C7.75545 18.036 8.17752 18.036 8.43785 18.2719L11.8379 21.3532C12.0983 21.5891 12.0983 21.9717 11.8379 22.2076Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.3337 22.9583C24.7269 22.9583 26.667 21.2001 26.667 19.0312C26.667 16.8623 24.7269 15.1041 22.3337 15.1041C19.9404 15.1041 18.0003 16.8623 18.0003 19.0312C18.0003 21.2001 19.9404 22.9583 22.3337 22.9583ZM22.3337 24.1666C25.4633 24.1666 28.0003 21.8674 28.0003 19.0312C28.0003 16.195 25.4633 13.8958 22.3337 13.8958C19.2041 13.8958 16.667 16.195 16.667 19.0312C16.667 21.8674 19.2041 24.1666 22.3337 24.1666Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.1722 17.9708C25.3125 18.2793 25.1502 18.6324 24.8098 18.7596L20.3642 20.4199C20.0238 20.547 19.6341 20.4001 19.4938 20.0915C19.3535 19.783 19.5158 19.4299 19.8562 19.3028L24.3018 17.6424C24.6422 17.5153 25.0319 17.6623 25.1722 17.9708Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupplementSvg);
export default __webpack_public_path__ + "static/media/SupplementSvg.eb4801109b46214f3379a52f299a7e6e.svg";
export { ForwardRef as ReactComponent };